module.exports = __webpack_public_path__ + "img/CM-SS-24-Subaru-Established.daac6406.jpg";